import React from 'react';
import { Card, Col, Placeholder, Row } from 'react-bootstrap';

const SUMMARY_ITEMS = 4;

export function BookingOverviewCardSkeleton() {
    return (
        <Card className="booking-card pb-5 pb-md-3 position-relative" aria-hidden="true">
            <Placeholder as="div" animation="glow" className="p-3">
                <Placeholder xs={9} className="skeleton d-block" />
                <Placeholder className="skeleton skeleton-number d-block mt-2" />
                <Placeholder className="skeleton skeleton-progress d-block my-3" />
                <div className="d-flex justify-content-between">
                    <Placeholder xs={4} className="skeleton" />
                    <Placeholder xs={3} className="skeleton" />
                </div>
                <div className="d-flex justify-content-between mt-2">
                    <Placeholder xs={3} className="skeleton" />
                    <Placeholder xs={3} className="skeleton" />
                </div>

                <div className="border-bottom border-light my-3" />

                <Placeholder xs={5} className="skeleton d-block mb-2" />
                <Row>
                    {Array.from({ length: SUMMARY_ITEMS }).map((_, i) => (
                        <Col key={i} sm={6} className="my-2">
                            <Placeholder className="skeleton skeleton-number d-block" />
                            <Placeholder xs={9} className="skeleton d-block mt-2" />
                        </Col>
                    ))}
                </Row>
            </Placeholder>

            <Placeholder as="div" animation="glow" className="px-3 d-flex justify-content-between">
                <Placeholder xs={5} className="skeleton skeleton-total" />
                <Placeholder xs={4} className="skeleton skeleton-total" />
            </Placeholder>
        </Card>
    );
}
